var render = function render(){var _vm=this,_c=_vm._self._c;return _c('res-select',{ref:"selector",attrs:{"id":_vm.elementId,"readonly":_vm.readonly,"items":_vm.properties,"attach":_vm.attachId,"loading":_vm.loading,"return-object":""},model:{value:(_vm.selectedProperty),callback:function ($$v) {_vm.selectedProperty=$$v},expression:"selectedProperty"}})
}
var staticRenderFns = []

export { render, staticRenderFns }